<template>
  <div>
    <slot></slot>
  </div>
</template>
<script>
import { mapActions } from 'vuex'

export default {
  name: 'SubQuestionJianda',
  props: {
    subId: {
      type: Number,
      required: true
    }
  },
  methods: {
    ...mapActions(['updateSubAnswer']),
    handleInput () {
      this.updateSubAnswer({
        index: this.subId, answer: 0
      })
    }
  },
  mounted () {
    this.handleInput()
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/_varaible.scss';
.desp{
  font-size:14px;
  font-family:SFProDisplay;
  font-weight:400;
  color:#A3B1BF;
  line-height:14px;
}
</style>
